import { render, staticRenderFns } from "./BMW.vue?vue&type=template&id=4c047fa8&scoped=true&"
import script from "./BMW.vue?vue&type=script&lang=js&"
export * from "./BMW.vue?vue&type=script&lang=js&"
import style0 from "./BMW.vue?vue&type=style&index=0&id=4c047fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c047fa8",
  null
  
)

export default component.exports